import React from "react";
import Applet from "../../Applet";
import ETLGoogleConfigurationTable from "../../../../components/Google/ETLGoogleConfigurationTable";

class ETLGoogleConfigurationTableApplet extends Applet {

    render() {
        return <ETLGoogleConfigurationTable applet={this}
                                       pageSize={this.state.PageSize}
                                       placement={this.state.Placement}
                                       columns={this.state.Columns}
                                       title="Google Drive Configurations"
                                       enterpriseComponent={this.getEnterpriseComponent()}
                                       sort={this.state.Sort}
                                       menu={this.state.Menu}
                                       rowHeight={this.state.RowHeight}
        />;
    }

    state = {
        Name: "ETLGoogleConfigurationTableApplet",
        Menu: {
            options: [
                {
                    displayValue: "New Google Drive Configuration",
                    value: "New Google Drive Configuration",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 40,
            "xs": 3,
            "sm": 3,
            "md": 40,
            "lg": 40,
            "lx": 40,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "Name",
                },
                {
                    id: "ServiceAccountEmail",
                },
                {
                    id: "ProjectID",
                },
                {
                    id: "Path",
                },
                {
                    id: "Actions",
                },
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "Name",
                width: 200,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "ServiceAccountEmail",
                width: 500,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Service Account Email",
            },
            {
                id: "ProjectID",
                width: 200,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Project ID",
            },
            {
                id: "Path",
                width: 300,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Path",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": 1,
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "DESC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                }]
            }
        ],
    };
}

export default ETLGoogleConfigurationTableApplet;
